module.exports = __webpack_public_path__ + "static/media/explore_icon.176b6024.svg";